import { Field } from "@chakra-ui/react"
import type { ComponentProps } from "react"

function ErrorText({ children, ...props }: ComponentProps<typeof Field.ErrorText>) {
  return (
    <Field.ErrorText color="red.500" {...props}>
      {children}
    </Field.ErrorText>
  )
}



export const AppField = {
  Root: Field.Root,
  Label: Field.Label,
  ErrorText,
  HelperText: Field.HelperText,
  RequiredIndicator: Field.RequiredIndicator,
}
